"use client"

import { Collapsible as CollapsiblePrimitive } from "@base-ui/react/collapsible"

import { asChildRender, type AsChildProps } from "@/components/ui/as-child"

function Collapsible({
  asChild,
  children,
  ...props
}: CollapsiblePrimitive.Root.Props & AsChildProps) {
  return (
    <CollapsiblePrimitive.Root
      data-slot="collapsible"
      {...props}
      {...asChildRender(asChild, children)}
    />
  )
}

function CollapsibleTrigger({
  asChild,
  children,
  ...props
}: CollapsiblePrimitive.Trigger.Props & AsChildProps) {
  return (
    <CollapsiblePrimitive.Trigger
      data-slot="collapsible-trigger"
      {...props}
      {...asChildRender(asChild, children)}
    />
  )
}

function CollapsibleContent({
  asChild,
  children,
  ...props
}: CollapsiblePrimitive.Panel.Props & AsChildProps) {
  return (
    <CollapsiblePrimitive.Panel
      data-slot="collapsible-content"
      {...props}
      {...asChildRender(asChild, children)}
    />
  )
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
